import React, { Component } from "react";
import { connect } from 'react-redux';
import SeoHeaders from "./seoheaders";
import {FormattedMessage} from "react-intl";
import * as wActs from "../actions/website-actions";

class NotFound extends Component {
  render() {
    return (
      <div className={`main-content left`}>
        <div className="models-listing">
          <div className="row">
            <div className="col_50" id={"noresultsimg"}>
              <img src={"/imgs/no-results-img.jpg"} width={"200"} height={"200"} alt={""}/>
            </div>
            <div className="col_50" id={"noresults"}>
              <h4 style={{fontSize: "24px", fontWeight: "bold"}}><FormattedMessage id={"page.404.pagenotfound"} >{(...content) => content}</FormattedMessage></h4>
              <div style={{color: '#454545', fontSize: "13px", paddingTop: "30px"}} dangerouslySetInnerHTML={{__html: this.props.Content.Main}}></div>
            </div>
            <div className="col_100" style={{height: '500px'}}>
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Content: state.Website.Page.Content
  };
}

export default connect(mapStateToProps)(NotFound);
